import cx from 'classnames';
import { startCase, toLower } from 'lodash';
import React, { Fragment, useState } from 'react';
import { useEffect } from 'react';
import { Button as BootstrapBtn, Image, Offcanvas } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { AddPlusIcon } from '../assets/icons';
import { USER_PROFILE_PLACEHOLDER } from '../config/constant/assetConstant';
import {
  With_Team_Member_Value,
} from '../constants/filters';
import { RemoveAllWhiteSpaceFromString } from '../helpers/jsHelper';
import {
  filterSelector,
  selectSelectedMembersBy,
  selectSelectedMembersTo,
  selectSharedPanelOpenBy,
  selectSharedTo,
  setSelectedAllMembers,
  setSelectedAllTeam,
  setSelectedMembersBy,
  setSelectedMembersTo,
  setSharedTo,
  setTotalOrganizationMembersCount,
} from '../redux/slicers/filters/filterSlicer';
import { paginatedTeamSelector } from "../redux/slicers/team/paginatedTeamSlicer";
import { selectTeamMembersFilterOpen } from '../redux/slicers/uiSlicer';
import { SKELETON_LOADER_TYPE } from '../skeletonLoaderUI/SkeletonLoaderUI';
import InfiniteScroll from './InfiniteScroll/InfiniteScroll';
import styles from './SideFilter/FilterItem.module.scss';
export const MemberOverlaySharedBy = ({
  show,
  sections,
  selected,
  onSelectAll,
  onSelect,
  onSearchChange,
  searchValue,
  onClose,
  maxVisible = 5,
}) => {
  const dispatch = useDispatch();
  const sharedPanelOpenBy = useSelector(selectSharedPanelOpenBy);
  const typeValue = useSelector(selectTeamMembersFilterOpen);
  const sharedTo = useSelector(selectSharedTo);
  const selectedMembersBy = useSelector(selectSelectedMembersBy);
  const selectedMembersTo = useSelector(selectSelectedMembersTo);
  const selectedMembers = useSelector((state) => filterSelector(state).members);
  const memberList = useSelector(paginatedTeamSelector);

  const totalSelected = selected.length;
  const itemsCount = sections.reduce((sum, section) => sum + section.items.length, 0);
  // const itemsCount = sections.find(s => s.name === 'INSIDE_MEMBERS').items.length
  
  let selectedIds = selected.map((m) => m.id);

  const handleGetList = () => {
    if (selectedMembers?.length && memberList?.list?.length) {
      let list = [];
      memberList?.list?.map((team) => {
        if (selectedMembers.some(({ id }) => +id === +team?.id)) {
          list.push({
            id: team?.id,
            name: team?.user?.name || team?.user?.first_name,
          });
        }
      });
      return list || [];
    } else {
      return [];
    }
  };

  const listToMemmber = [...selectedMembers, ...selectedMembersBy];
  let shareByTeamMember = [];
  listToMemmber?.map((list) => {
    if (!handleGetList()?.find((info) => +info?.id === +list?.id)) {
      shareByTeamMember.push(list);
    }
  });
  selectedIds = [...selectedIds, ...shareByTeamMember?.map((m) => m.id)];
  selectedIds = Array.from(new Set(selectedIds))
  const allSelected = (itemsCount === totalSelected || (itemsCount === (selectedIds?.length + 1))) && (totalSelected !== 0 || selectedIds !== 0);

  const maxVisibleList = (data, key) => {
    let list = data?.find(({ name }) => name === key);
    if (list) {
      list = [
        {
          ...list,
          items: list?.items?.slice(0, maxVisible),
        },
      ];
    } else {
      list = [];
    }
    return list;
  };

  const [open, setOpen] = useState(false);
  const moreCount =
    (sections?.find(({ name }) => name === 'INSIDE_MEMBERS')?.items?.length || 0) - maxVisible;
  const visibleItems =
    moreCount > 0 && !open ? maxVisibleList(sections, 'INSIDE_MEMBERS') : sections;

  const [openOther, setOpenOther] = useState(false);
  const otherMoreCount =
    (sections?.find(({ name }) => name === 'OUTSIDE_MEMBERS')?.items?.length || 0) - maxVisible;
  const otherVisibleItems =
    otherMoreCount > 0 && !openOther ? maxVisibleList(sections, 'OUTSIDE_MEMBERS') : sections;

  const handleSelectAll = () => {
    if (allSelected && totalSelected === 0) {
      dispatch(setSelectedMembersBy([]));
      dispatch(setSelectedMembersTo([]))
    } else {
      onSelectAll();
    }
  };

  const handleSelect = (item) => {
    const selectedItem = selected.map((m) => m?.id)
    if (!selectedItem.includes(item.id)) {
      onSelect(item)
    } else {
      onSelect(item)
      onSelect(item)
    }
  }

  return (
    <div
      className={`files-shared-with-users-container designV2 ${
        sections[0]?.hasMore ? '--has-more-items' : ''
      }`}>
      <div className="filter-form">
        <div className="inside members mb-0 pb-0">
          {/* Share by team member */}
          <div className={`${styles.root} filter-root-item accordion-item`}>
            <div>
              <h5
                className="accordion-header"
                id={`panelsStayOpen-heading${RemoveAllWhiteSpaceFromString('Shared by'?.trim())}`}>
                <div
                  className="accordion-button d-flex justify-content-between collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target={`#panelsStayOpen-collapse${RemoveAllWhiteSpaceFromString(
                    'Shared by'?.trim()
                  )}`}
                  aria-expanded="false"
                  aria-controls={`panelsStayOpen-collapse${RemoveAllWhiteSpaceFromString(
                    'Shared by'?.trim()
                  )}`}>
                  <div className="main-text">Shared by</div>
                </div>
              </h5>
            </div>

            <div
              id={`panelsStayOpen-collapse${RemoveAllWhiteSpaceFromString('Shared by'?.trim())}`}
              className="accordion-collapse collapse"
              aria-labelledby={`panelsStayOpen-heading${RemoveAllWhiteSpaceFromString(
                'Shared by'?.trim()
              )}`}>
              <>
                <div className="all-user-select py-2">
                  <div className="filter select_all checkbox-selection">
                    <input
                      type="checkbox"
                      id="membersOverlaySelectAllShare"
                      className="selectCard"
                      checked={allSelected}
                      onChange={handleSelectAll}
                    />
                    <label htmlFor="membersOverlaySelectAllShare"></label>
                  </div>
                  <label htmlFor="membersOverlaySelectAllShare">All</label>
                  <label className="selectionCount"></label>
                </div>

                {/* list code */}
                {visibleItems?.map((section, idx) => {
                  const { items, noItemsText, loading, hasMore, fetchMoreData } = section;

                  if (section?.name === 'OUTSIDE_MEMBERS') return null;

                  return (
                    <Fragment key={idx}>
                      <div className={`members ${idx > 0 ? 'outside' : 'inside'}`}>
                        {items.length === 0 && !loading && noItemsText}
                        <InfiniteScroll
                          loading={items?.length && !searchValue ? false : loading}
                          loadingType={SKELETON_LOADER_TYPE.MEMBER}
                          hasMore={hasMore}
                          next={fetchMoreData}>
                          {items.length > 0 && (
                            <ul className="user-list">
                              {items.map((item) => {
                                const itemSelected = selectedIds.includes(item.id);
                                const { name, avatar, organization } = item;
                                return (
                                  <li className={cx('teamMemberFilter')} key={item.id}>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value={itemSelected}
                                      checked={itemSelected}
                                      onClick={() =>handleSelect(item)  }
                                    />
                                    <Image src={avatar ? avatar : USER_PROFILE_PLACEHOLDER} />
                                    <div className="user-info">
                                      <h5 className="user-name userName">{name}</h5>
                                      {organization && (
                                        <p className="user-org ellipsis" title={organization}>
                                          {startCase(toLower(organization))}
                                        </p>
                                      )}
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          )}
                        </InfiniteScroll>
                      </div>
                    </Fragment>
                  );
                })}
              </>
              {+moreCount > 0 ? (
                <div className={`more pt-1`}>
                  <span
                    className={`${open ? 'show-more' : ''} more-option`}
                    onClick={() => setOpen(!open)}>
                    {!open && (
                      <>
                        <AddPlusIcon />
                        {`View more (${moreCount})`}
                      </>
                    )}
                    {open && (
                      <>
                        <AddPlusIcon />
                        Show less
                      </>
                    )}
                  </span>
                </div>
              ) : null}
            </div>
          </div>
          {/* share by other org */}
          <div className={`${styles.root} filter-root-item accordion-item`}>
            <div>
              <h5
                className="accordion-header"
                id={`panelsStayOpen-heading${RemoveAllWhiteSpaceFromString(
                  'Shared by other Organization'?.trim()
                )}`}>
                <div
                  className="accordion-button d-flex justify-content-between collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target={`#panelsStayOpen-collapse${RemoveAllWhiteSpaceFromString(
                    'Shared by other Organization'?.trim()
                  )}`}
                  aria-expanded="false"
                  aria-controls={`panelsStayOpen-collapse${RemoveAllWhiteSpaceFromString(
                    'Shared by other Organization'?.trim()
                  )}`}>
                  <div className="main-text">Shared by other Organization</div>
                </div>
              </h5>
            </div>

            <div
              id={`panelsStayOpen-collapse${RemoveAllWhiteSpaceFromString(
                'Shared by other Organization'?.trim()
              )}`}
              className="accordion-collapse collapse"
              aria-labelledby={`panelsStayOpen-heading${RemoveAllWhiteSpaceFromString(
                'Shared by other Organization'?.trim()
              )}`}>
              <>
                {/* list code */}

                {otherVisibleItems?.map((section, idx) => {
                  const { items, noItemsText, loading, hasMore, fetchMoreData } = section;
                  if (section?.name === 'INSIDE_MEMBERS') return null;
                  return (
                    <Fragment key={idx}>
                      <div className={`members ${idx > 0 ? 'outside' : 'inside'}`}>
                        {items.length === 0 && !loading && noItemsText}
                        <InfiniteScroll
                          loading={items?.length && !searchValue ? false : loading}
                          loadingType={SKELETON_LOADER_TYPE.MEMBER}
                          hasMore={hasMore}
                          next={fetchMoreData}>
                          {items.length > 0 && (
                            <ul className="user-list">
                              {items.map((item) => {
                                const itemSelected = selectedIds.includes(item.id);
                                const { name, avatar, organization } = item;
                                return (
                                  <li className={cx('teamMemberFilter')} key={item.id}>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value={itemSelected}
                                      checked={itemSelected}
                                      onClick={() => handleSelect(item)}
                                    />
                                    <Image src={avatar ? avatar : USER_PROFILE_PLACEHOLDER} />
                                    <div className="user-info">
                                      <h5 className="user-name userName">{name}</h5>
                                      {organization && (
                                        <p className="user-org ellipsis" title={organization}>
                                          {startCase(toLower(organization))}
                                        </p>
                                      )}
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          )}
                        </InfiniteScroll>
                      </div>
                    </Fragment>
                  );
                })}
              </>
              {+otherMoreCount > 0 ? (
                <div className={`more pt-1`}>
                  <span
                    className={`${openOther ? 'show-more' : ''} more-option`}
                    onClick={() => setOpenOther(!openOther)}>
                    {!openOther && (
                      <>
                        <AddPlusIcon />
                        {`View more (${otherMoreCount})`}
                      </>
                    )}
                    {openOther && (
                      <>
                        <AddPlusIcon />
                        Show less
                      </>
                    )}
                  </span>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
